export default __webpack_public_path__ + "static/media/status-500-banner.aa15d626.svg";